<template>
  <v-app>
    <div class="pt-5 mt-5">
      <div class="px-5 mt-5 pt-5 text-center">
        <v-col cols="auto">
          <!--            edit-mode-->
          <v-dialog
              transition="dialog-bottom-transition"
              max-width="600"
              v-model="editModal"
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                    color="primary"
                    dark
                    class="text-center"
                >
                  <v-toolbar-title>بررسی وضعیت چت</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                      icon
                      class="mr-auto"
                      @click="editModal = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-col class="py-0">
                    <v-text-field
                        v-model="ChatInfo.keyWord"
                        label="کلیدواژه"
                        outlined
                        dense
                        readonly
                        class="mt-5"
                        prepend-inner-icon="fa fa-pencil-alt"
                        style="direction: rtl;"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0">
                    <v-textarea
                        v-model="ChatInfo.message"
                        label="پیام"
                        prepend-inner-icon="fa fa-pencil-alt"
                        outlined
                        readonly
                        dense
                        style="direction: rtl;"
                    ></v-textarea>
                  </v-col>
                  <v-col class="py-0">
                    <v-autocomplete
                        v-model="ChatInfo.status"
                        label="وضعیت"
                        prepend-inner-icon="fa fa-pencil-alt"
                        outlined
                        item-text="name"
                        item-value="value"
                        dense
                        :items="chatStatus"
                        style="direction: rtl;"
                    ></v-autocomplete>
                  </v-col>
                  <v-col v-if="ChatInfo.status === 'unverified' ">
                    <v-textarea
                        v-model="ChatInfo['reasons']"
                        label="دلیل رد شدن"
                        outlined
                        dense
                        placeholder="در چندین کلمه دلیل رد شدن این چت را بنویسید."
                        prepend-inner-icon="fa fa-pencil-alt"
                        style="direction: rtl;"
                    ></v-textarea>
                  </v-col>
                  <v-btn
                      class="btn-update "
                      @click="UpdateStatus"
                  ><span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                    ثبت وضعیت
                  </v-btn>
                </v-card-text>
              </v-card>
            </template>
          </v-dialog>
          <!--            edit-mode-->
        </v-col>
        <v-card :loading="loading" class="p-3 pt-0">

          <terminal-table class="col-12" :currentPage="data.current_page"
                          :perPage="data.per_page" v-if="isMobile" :getData="getDataForTable"
                          :pageCount="data.last_page"
                          :options="tableProps" :datas="data" :headers="columns"></terminal-table>

          <data-table
              v-else
              :data="data"
              :columns="columns"
              :debounce-delay="3000"
              :translate="translate"
              :orderBy="tableProps.column"
              :pagination="paginate"
              :orderDir="tableProps.dir"
              :per-page="[10, 25, 50, 100, 500]"
              @on-table-props-changed="reloadTable"
              :loading="true"
              class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
          >
            <template slot="filters" slot-scope="{ tableFilters, perPage }">
              <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                             v-model="searchBox"></filters-table>
            </template>
          </data-table>
        </v-card>
      </div>
    </div>
  </v-app>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {dataTableProps} from "@/main";
import Swal from "sweetalert2";
import button from "@/view/pages/button";
import {debounce} from "../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "jobsList",
  components: {FiltersTable, TitleRibbon},
  data() {
    return {
      dialog: false,
      editModal: false,
      loading: false,
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      groupModal: false,
      ChatInfo: {},
      status: '',
      chargeMount: '',
      chatStatus: [
        {name: 'رد شده', value: 'unverified',},
        {name: 'تایید شده', value: 'verify',}
      ],
      numbersInfo: false,
      selectedNumber: [],
      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'کاربر',
          name: 'user.name',
          primary: true,
          transform(val) {
            return val.data.user.name + ' ' + val.data.user.lastName
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'وضعیت ',
          name: 'status',
          primary: true,
          transform: (val) => {
            const error = {
              verify: {text: 'تایید شده', color: 'success'},
              waiting: {text: 'در انتظار تایید', color: 'warning'},
              unverified: {text: 'رد شده', color: 'danger'},
            };
            return `<span class="badge badge-${error[val.data.status].color}">${error[val.data.status].text}</span>`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            buttons: [
              {
                name: 'delete',
                label: 'بروز رسانی وضعیت',
                icon: 'edit',
                class: 'btn-outline-warning',
                action: this.actions,
                status: 'divar_delete',
              },
            ]
          }
        }
      ],
      data: {},
      url: `${url}/admin/monitoring/chats`,
      searchBox: {
        search: '',
        length: 10
      },

    }
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }

  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data.data;
          vm.loading = false;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
    UpdateStatus: function () {
      $.ajax({
        url: `${url}/admin/monitoring/chats/${this.dataId}`,
        method: 'PUT',
        fn: this.UpdateStatus,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        data: {
          "status": this.ChatInfo.status,
          "message": this.ChatInfo.reasons,

        },
        msg: true,
        success: (res) => {
          this.getDataForTable(this.url, this.tableProps);
          this.editModal = false;
        }
      });
    },
    actions(data, type) {
      this.editModal = true;
      this.dataId = data.id
      this.ChatInfo = {
        keyWord: data.keyword,
        message: data.message,
        status: data.status
      }
    },
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })
  },
}
</script>

<style scoped>

</style>